import { ProductImage, Price } from '@kega/sps-components';
import { useConfig, useUpdateCart, useRemoveFromCart } from '@kega/sps-core';
import { Loader } from '@kega/sps-elements';

import Counter from '../../../components/counter/Counter';
import { MinIcon, MaxIcon, TrashbinIcon } from '../../../components/icons';

import useUserId from "../../../hooks/useUserId";
import useTagManager from '../../../hooks/useTagManager';
import useItemCategories from '../../../hooks/useItemCategories';

import classes from './CartItem.module.css';

const CartItem = ({ product, totalPrice, quantity, entryNumber }) => {
    const { updateCart, loading: loadingUpdate } = useUpdateCart();
    const { removeItem, loading: loadingRemove } = useRemoveFromCart();

    const getUserId = useUserId();
    const config = useConfig();
    const locale = config.get('locale');
    const currency = config.get('currency');
    
    const { code, name, Merk, stock = {}, categoryPath, images = [], assortmentMinQuantity } = product;
    const stockLevel = stock.stockLevel || 9999;
    const minQuantity = assortmentMinQuantity || 1;
    const productName = product?.formattedName || product?.name;
    const itemCategories = useItemCategories(categoryPath);
    const { ecommerceEvent } = useTagManager();

    const onQtyChange = (value) => {
        updateCart({
            product: { code: code },
            quantity: value,
            entryNumber: entryNumber,
            userId: getUserId()
        });
    };

    const onRemove = () => {
        try {

            ecommerceEvent('remove_from_cart', {
                value: totalPrice?.value,
                currency: currency,
                items:[{
                    item_id: code,
                    item_name: productName,
                    item_brand: Merk ?? product?.manufacturer,
                    price: totalPrice?.value,
                    item_category: itemCategories[0],
                    item_category2: itemCategories[1],
                    item_category3: itemCategories[2],
                    item_category4: itemCategories[3],
                    item_category5: itemCategories[4],
                }]
            });
        } catch (error) {
            console.log(error)
        }

        removeItem({
            entryNumber: entryNumber,
            userId: getUserId()
        });

    }

    return (
        <div className={classes.root}>
            
            <div className={classes.image}>
                <ProductImage
                    src={(images[0] ? images[0].url : '/images/placeholder.png')}
                    width={256}
                    height={256}
                    alt={name}
                />
            </div>

            <div className={classes.details}>

                <div className={classes.name}>
                    { productName }
                </div>

                <div style={{ display:'flex', alignItems:'center' }}>
                    <button className={classes.remove} onClick={onRemove}>
                        <TrashbinIcon color="#73082F" />
                    </button>
                    <div className={classes.quantity}>
                        <Counter
                            name="quantity"
                            value={quantity}
                            min={minQuantity}
                            max={stockLevel}
                            step={minQuantity}
                            parentCallback={onQtyChange}
                            trigger="blur"
                            minComponent={MinIcon}
                            maxComponent={MaxIcon}
                        />
                    </div>
                    <div className={classes.price}>
                        <Price
                            price={totalPrice.value}
                            currency={currency}
                            locale={locale}
                            currencySymbol={false}
                        />
                    </div>
                </div>

            </div>

            { loadingUpdate ? <div className={classes.loading}><Loader variant="primary" /></div> : null }

        </div>
    );
}

export default CartItem;